import React from "react";

interface SubSectionProps {
    title?: string;
    children: React.ReactNode;
    description?: React.ReactNode;
}

const TabSection = (props: SubSectionProps) => {
    return (
        <section className="w-full mb-10 font-lato">
            <header className="mb-4">
                {props.title && <h2 className="an-section-heading">{props.title}</h2>}
                {props.description && (
                    <div className="text-an-muted-3 text-sm">{props.description}</div>
                )}
            </header>
            <div className="an-panel">
                <div className="flex flex-wrap gap-6 w-full">
                    {props.children}
                </div>
            </div>
        </section>
    );
};

export default TabSection;
